export default __webpack_public_path__ + "static/media/serendipity-reports.32edcf17.png";